import PropTypes from "prop-types";
import { useClientContext } from "../../ClientContext.jsx";
import { RADIUS } from "../../shared/theme.js";

export default function SuccessSection({
  importState,
  importPeriod,
  handleImportReset,
  onRunAnalysis,
  analysisLoading,
}) {
  const { T } = useClientContext();

  if (importState !== "done") return null;

  return (
    <div
      style={{
        background: "#DCFCE7",
        border: "1px solid #86EFAC",
        borderRadius: RADIUS.md,
        padding: "14px 18px",
        marginTop: 8,
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <span style={{ fontSize: 22 }}>✅</span>
      <div style={{ flex: "1 1 200px" }}>
        <div style={{ fontWeight: 700, color: "#15803D", fontSize: 13 }}>
          Snapshot {importPeriod} salvo com sucesso!
        </div>
        <div style={{ fontSize: 12, color: "#166534", marginTop: 2 }}>
          O dashboard do cliente será atualizado automaticamente na próxima visita.
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, marginLeft: "auto" }}>
        {onRunAnalysis && (
          <button
            onClick={onRunAnalysis}
            disabled={analysisLoading}
            title="Gerar relatório de análise do portfólio (.docx)"
            style={{
              padding: "8px 16px",
              borderRadius: RADIUS.sm,
              border: "none",
              background: analysisLoading ? "#94A3B8" : "#0F3460",
              color: "#fff",
              fontSize: 12,
              fontWeight: 700,
              cursor: analysisLoading ? "wait" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {analysisLoading ? "⏳ Gerando…" : "📊 Rodar Análise"}
          </button>
        )}
        <button
          onClick={handleImportReset}
          style={{
            padding: "8px 16px",
            borderRadius: RADIUS.sm,
            border: "none",
            background: "#16A34A",
            color: "#fff",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Nova importação
        </button>
      </div>
    </div>
  );
}

SuccessSection.propTypes = {
  importState: PropTypes.string.isRequired,
  importPeriod: PropTypes.string.isRequired,
  handleImportReset: PropTypes.func.isRequired,
  onRunAnalysis: PropTypes.func,
  analysisLoading: PropTypes.bool,
};
